import React, { useCallback } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'react-toastify';
import {
  useFormCepAutocomplete,
  IProfileSchema,
  profileSchema,
} from '@area-restrita/client';
import {
  useGetProfileSuspense,
  useUpdateProfile,
} from '@area-restrita/api-client/endpoints/profile/profile.gen';

import { Form } from '@/components/ui/form';

import ProfileView from './view';

const Profile: React.FC = () => {
  const { data } = useGetProfileSuspense();

  const form = useForm<IProfileSchema>({
    defaultValues: {
      fullName: data.fullName ?? '',
      email: data?.email,
      password: '',
      newPassword: '',
      confirmPassword: '',
      phone: data.phone ?? '',

      address: {
        zipCode: data.address?.zipCode,
        state: data.address?.state
          ? { label: data.address.state.name, value: data.address.state.id }
          : undefined,
        city: data.address?.city
          ? { label: data.address.city.name, value: data.address.city.id }
          : undefined,
        neighborhood: data.address?.neighborhood,
        street: data.address?.street,
        number: data.address?.number,
        complement: data.address?.complement,
      },
    },
    resolver: zodResolver(profileSchema),
    reValidateMode: 'onChange',
    mode: 'all',
  });

  useFormCepAutocomplete(form, 'address');

  const { mutateAsync } = useUpdateProfile();

  const handleSubmit = useCallback<SubmitHandler<IProfileSchema>>(
    ({ address, ...data }) =>
      mutateAsync(
        {
          data: {
            ...data,
            address: {
              ...address,
              cityId: address.city.value,
            },
          },
        },
        {
          onSuccess: () => toast.success('Perfil atualizado com sucesso'),
          onError: () => toast.error('Erro ao atualizar perfil'),
        },
      ),
    [mutateAsync],
  );

  return (
    <Form {...form}>
      <ProfileView
        control={form.control}
        isDirty={form.formState.isDirty}
        onReset={() => form.reset()}
        onSubmit={form.handleSubmit(handleSubmit, console.error)}
      />
    </Form>
  );
};

export default Profile;
